var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0.25 0.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 44,
    height: 44,
    rx: 2,
    transform: "translate(-0.25 -0.167)",
    fill: "#e6b81f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MDI_account-arrow-left-outline",
    "data-name": "MDI / account-arrow-left-outline",
    transform: "translate(5.417 5.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(0.333 0.417)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_account-arrow-left-outline",
    "data-name": "Path / account-arrow-left-outline",
    d: "M24.533,28.917l-4.225-4.4,4.225-4.4v2.931h5.633v2.931H24.533v2.931m-7.042-4.4a7.493,7.493,0,0,0,.591,2.931H2v-4.4c0-3.239,5.042-5.863,11.267-5.863a20.664,20.664,0,0,1,4.014.381,15.8,15.8,0,0,1,3.183.967,7.416,7.416,0,0,0-2.972,5.98M4.817,23.054V24.52h9.858a10.559,10.559,0,0,1,.9-4.28l-2.31-.117c-4.662,0-8.45,1.319-8.45,2.931M13.267,4A5.751,5.751,0,0,1,18.9,9.863a5.751,5.751,0,0,1-5.633,5.863A5.751,5.751,0,0,1,7.633,9.863,5.751,5.751,0,0,1,13.267,4m0,2.931A2.876,2.876,0,0,0,10.45,9.863a2.819,2.819,0,1,0,5.633,0A2.876,2.876,0,0,0,13.267,6.931Z",
    transform: "translate(0.167 0.333)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.7256132efeff29bd7ac4b03cdaf4de58.svg";
export { ForwardRef as ReactComponent };